<template>
    <content-view
        class="accountAdd"
    >
        <div class="bg-white pl32 pr32 pt32">
            <div class="text-black-85 font-big bold pb24">账号信息</div>
            <a-form
                @submit="handleSubmit"
                :form="form"
            >
                <a-form-item
                    class="form-item"
                    label="名称："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-input
                        placeholder="请输入"
                        onfocus="this.removeAttribute('readonly');"
                        v-decorator="[
                            'username',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入名称',
                                        max:12
                                    }
                                ]
                            }
                        ]"
                    />
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="手机号："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-input
                        placeholder="请输入"
                        onfocus="this.removeAttribute('readonly');"
                        v-decorator="[
                            'phone',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入手机号',
                                        pattern: $regular.phone
                                    }
                                ]
                            }
                        ]"
                    />
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="密码："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-input
                        placeholder="请输入"
                        type="password"
                        v-decorator="[
                            'password',
                            {
                                rules: [
                                    {
                                        required: isEdit ? false : true,
                                        message:
                                            '请输入员工密码（8-20位数字或者字母组合）',
                                        pattern: $regular.password
                                    }
                                ]
                            }
                        ]"
                    />
                </a-form-item>
                <a-form-item
                    label='区域：'
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-select
                        placeholder="请选择区域"
                        v-decorator="[
                            'district_code',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message:'请选择区域',

                                    }
                                ]
                            }
                        ]"
                    >
                        <a-select-option
                            v-for="item in statusList"
                            :value="item.district_code"
                            :key="item.district_code"
                        >
                            {{item.district}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="text-center footerButton pt24">
                    <a-button
                        class="mr16"
                        @click="cancel"
                    >取 消</a-button>
                    <a-button
                        type="primary"
                        htmlType="submit"
                    >{{ isEdit ? '更 新' : '确 定' }}</a-button>
                </a-form-item>
            </a-form>
            
        </div>
    </content-view>
</template>

<script>
export default {
    name: "accountDetail",
    data() {
        return {
            isEdit: false,
            id: "",
            form: this.$form.createForm(this),
            statusList:[],
            detail:{},
        };
    },
    watch: {

    },
    methods: {
        // 获得区域列表
        getRole() {
            this.$api.common.regionList().then(res => {
                this.statusList = res.data.list;
            });
        },
        
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    
                    if (this.isEdit) {
                        values.id = this.id;
                        !values.password && delete values.password;
                        if(values.password){
                            values.password = this.$md5(values.password);
                        }
                        
                        this.$api.account.accountSave(values).then(res => {
                            if(res.data.error_no){
                                this.$message.error(res.msg);
                            }else{
                                this.$message.success(res.msg);
                                this.$router.push({
                                    name: "accountList"
                                });
                            }
                            
                        });
                    } else {
                        values.password = this.$md5(values.password);
                        this.$api.account.accountAdd(values).then(res => {
                                if(res.data.error_no){
                                    this.$message.error(res.msg);
                                }else{
                                    this.$message.success(res.msg);
                                    this.$router.push({
                                        name: "accountList"
                                    });
                                }
                                
                            });
                    }
                    
                }
            });
        },
        // 取消
        cancel() {
            this.$utils.showConfirm(() => {
                this.$router.push({
                    name: "accountList"
                });
            }, this);
        },
        getDetail() {
            let formData = {
                id:this.id
            }
            this.$api.account.accountInfo(formData).then(res => {
                this.detail = res.data;
                let arr = ["username", "phone","district_code"];
                this.form.setFieldsValue(
                    this.$utils.getRequestData(arr, res.data)
                );
            });
        },
    },
    computed: {},
    created() {
        this.getRole();
        if (this.$route.query.id) {
            this.isEdit = true;
            this.id = this.$route.query.id;
            this.getDetail();
        } 
    }
};
</script>


<style rel="stylesheet/scss" lang="scss">
.wrap-container > div{
    flex: auto;
}
.accountAdd {
    .bold {
        font-weight: bold;
    }
    .ant-upload.ant-upload-drag {
        height: 202px;
    }
    .ant-upload.ant-upload-drag .ant-upload {
        padding: 0;
    }
    .icon-add {
        font-size: 40px;
    }
    .image {
        height: 200px;
    }
    .ant-checkbox-wrapper {
        width: 175px;
    }
    .editbtn {
        color: rgba(8, 106, 204, 1);
    }
}
.ql-picker,
.ql-picker-label {
    line-height: 24px;
}
</style>
